export default __webpack_public_path__ + "static/media/tfp-menu-bg@2x.7054a066.png";